<script lang="ts">
</script>

<svg data-testid="play-svg" width="1em" height="1em" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path
    d="M18.7301 11.3693L6.15573 0.174345C5.68683 -0.241547 5 0.133438 5 0.805001V23.195C5 23.8666 5.68683 24.2415 6.15573 23.8257L18.7301 12.6307C19.09 12.3102 19.09 11.6898 18.7301 11.3693Z"
    fill="#F5F5F5" />
</svg>
